<template>
  <v-dialog v-model="visible" max-width="800" persistent>
    <v-card v-if="visible" class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title.${type}`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          @click.native="close(null)"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          :placeholder="$t(`${namespace}.inputPlaceholder`)"
          hide-details
          single-line
          flat
          outline
          solo
          color="accent"
          class="mb-3"
        />

        <v-data-table
          :headers="table.headers"
          :items="table.body"
          :search="search"
          :pagination.sync="pagination"
          hide-actions
          color="accent"
          :no-results-text="$t(`${namespace}.noResultsText`)"
          :no-data-text="$t(`${namespace}.noDataText`)"
        >
          <template v-if="type === 'success'" v-slot:items="props">
            <td :title="props.item.orderId">
              {{ props.item.orderId }}
            </td>
            <td :title="props.item.paymentMethod">
              {{ props.item.paymentMethod }}
            </td>
            <td :title="props.item.value | currencyBRL">
              {{ props.item.value | currencyBRL }}
            </td>
            <td :title="props.item.description">
              {{ props.item.description }}
            </td>
            <td :title="props.item.billingNewOrder">
              {{ props.item.billingNewOrder ? $t('Common.yes') : $t('Common.no') }}
            </td>
          </template>

          <template v-else v-slot:items="props">
            <td :title="props.item.lineNumber">
              {{ props.item.lineNumber }}
            </td>

            <td :title="props.item.sheetName">
              {{ props.item.sheetName }}
            </td>

            <td :title="props.item.error">
              {{ props.item.error }}
            </td>
          </template>
        </v-data-table>

        <div v-if="pagination.totalItems > pagination.rowsPerPage" class="text-xs-center mt-3">
          <v-pagination
            v-model="pagination.page"
            :length="pages"
            color="accent"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PreviewImportedLinesDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  computed: {
    pages () {
      return this.pagination.rowsPerPage ? Math.ceil(this.table.body.length / this.pagination.rowsPerPage) : 0
    },

    totalVisible () {
      return window.innerWidth <= 420 ? 5 : 7
    }
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage.previewImportedLinesDialog',
      search: '',
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 6,
        sortBy: 'name'
      },
      table: {
        headers: [],
        body: []
      }
    }
  },
  methods: {
    close (reload = null) {
      this.$emit('close', reload)
    },

    clearFields () {
      this.search = ''
      this.pagination = {
        descending: false,
        page: 1,
        rowsPerPage: 6,
        sortBy: 'name'
      }
    },

    setTableData () {
      if (this.type === 'success') {
        this.table = {
          headers: [
            { text: this.$t(`${this.namespace}.orderId`), value: 'orderId' },
            { text: this.$t(`${this.namespace}.paymentMethod`), value: 'paymentMethod' },
            { text: this.$t(`${this.namespace}.value`), value: 'value' },
            { text: this.$t(`${this.namespace}.description`), value: 'description' },
            { text: this.$t(`${this.namespace}.billingNewOrder`), value: 'billingNewOrder' }
          ],
          body: this.data.map(item => {
            const { orderId, paymentMethod, value, description, billingNewOrder = false } = item
            return { orderId, paymentMethod, value, description, billingNewOrder }
          })
        }
      }

      if (this.type === 'error' || this.type === 'workerErrors') {
        this.table = {
          headers: [
            { text: this.$t(`${this.namespace}.lineNumber`), value: 'lineNumber' },
            { text: this.$t(`${this.namespace}.tab`), value: 'sheetName' },
            { text: this.$t(`${this.namespace}.error`), value: 'error' }
          ],
          body: this.data.map(item => {
            return {
              lineNumber: item.lineNumber,
              sheetName: item.sheetName,
              error: item.messages[0]
            }
          })
        }
      }
    }
  },
  watch: {
    data () {
      this.setTableData()
    },

    visible () {
      this.clearFields()
    }
  }
}
</script>
